import React from 'react';
import Button from '@mui/material/Button';
import { brandColors } from 'brandColors';

const MarketingPricingCard = ({ name, title, subtitle, displayedColor, onPackSelected }) => {
  let colorKey = 'blue';
  for (const [key, value] of Object.entries(brandColors.colors)) {
    if (value.DEFAULT && value.DEFAULT.toLowerCase() === displayedColor.toLowerCase()) {
      colorKey = key;
      break;
    }
  }
  let style = {
    backgroundColor: brandColors.colors[colorKey][600],
    color: brandColors.colors[colorKey].DEFAULT,
    borderColor: brandColors.colors[colorKey].DEFAULT,
    marginTop: 'auto',
  };
  return (
    <div
      className="flex flex-col p-4 bg-white space-y-2 border max-w-[33.33%]"
      style={{ minHeight: '236px', borderColor: style.borderColor }}
    >
      <h2 className="font-bold text-dark">{name}</h2>
      <h3 className="font-bold text-gray-900">{title}</h3>
      <p className="font-regular text-dark">{subtitle}</p>
      <Button
        className="mt-auto"
        variant="outlined-info"
        onClick={onPackSelected}
        style={style}
        fullWidth={true}
        sx={{
          ':hover': {
            backgroundColor: `${brandColors.colors[colorKey][500]} !important`,
          },
        }}
      >
        <h4 className="medium">Upgrade Now!</h4>
      </Button>
    </div>
  );
};

export { MarketingPricingCard };
